module.exports = __webpack_public_path__ + "img/showcase.5c541783.jpeg";